import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * ReportSummary Widget
 */
@Component({
  selector: 'report-summary-widget',
  templateUrl: './report-summary-widget.component.html',
  styleUrls: ['./report-summary-widget.component.scss']
})
export class ReportSummaryWidgetComponent extends WidgetBaseComponent implements OnInit{

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'reportSummary', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {    
    this.useDefaultServiceSaveChangesHandler("reportSummary", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.loadReflist('ref_l2_projectstd_valuationmethod');
    this.mockupData$ = this.widgetService.loadMockup('reportSummary');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('reportSummary', this.getReport());
  }


  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    this.setDirtyFlag(false);
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }
}

